export default function getSchoolYearClasses(yearclasses, year) {
  const currentClasses = yearclasses.filter((y) => y.calendarYear === year)

  return currentClasses
}
